/* eslint-disable */
import "./Footer.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Image from "react-bootstrap/Image";

function Footer() {
  return (
    <div className="footer">
      <footer className="py-3 my-4">
        <p className="text-center dark:text-gray-300">© 2022-2026 Foorweb, Inc</p>
      </footer>
      {/* <OverlayTrigger
        placement="top"
        overlay={<Tooltip>الدعم مع بلال</Tooltip>}
      >
        <a
          className="whatsup1 image-live"
          href="https://meet.google.com/cbw-oqfq-svc"
          target="_blank"
        >
          <Image className="rounded feature-container" src={"/live.png"} />
        </a>
      </OverlayTrigger> */}
     
    </div>
  );
}

export default Footer;
